import {LabelFormFieldTypography} from "patient-ping-remedy/packages/typography";
import {sizes} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';

export const StyledLabelFormFieldTypography = styled(LabelFormFieldTypography)`
  margin-bottom: ${sizes.xSmall};
  display: block;
`;

export const ChipWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${sizes.xSmall};
    margin-bottom: ${sizes.xSmall};

    button:hover {
       cursor: pointer;
    }
`;
